import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { TimeSyncState } from './types';

const state: TimeSyncState = {
  offset: 0
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
